import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { checkemail, required } from "../Common/validation";
import InputGroup from "react-bootstrap/InputGroup";
import {  useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import ".././css/common.css";
import { APPLICATION_ID, AUTH_BASE_URL, BASE_URL } from "../Config/Config";
import Navbarp from "../Components/CommonComponents/Navbarp";
import { setTempToken } from "../features/Loginuser";
import { Spinner } from "react-bootstrap";
import SmallLoader from "../Components/CommonComponents/SmallLoader";
import { useEffect } from "react";

function Forgotpassword() {
  const [Username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [Usernameerror, setUsernameerror] = useState("");
  const [response, setResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailerror, setEmailerror] = useState("");
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  function handleSubmit(e) {
    e.preventDefault();

    var emailval = validate(email, "email");

    if (emailval) {
      setLoading(true);

      fetch(AUTH_BASE_URL + "/auth/send-otp", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        //make sure to serialize your JSON body
        body: JSON.stringify({
          username: email,
          applicationId: APPLICATION_ID,
        }),
      })
        .then((response) => response.json())
        //Then with the data from the response in JSON...
        .then((data) => {
          if (data.success) {
            dispatch(setTempToken(data.data.username))
            setLoading(false);
            setResponse(true);
            setMessage(data.message);
            setUsername("");
            e.target.reset();
          }
        });
    }
  }
  function validate(data, type) {
    switch (type) {
      case "email":
        if (required(data)) {
          setEmailerror("Email cannot be blank");
          return false;
        } else if (!checkemail(data)) {
          setEmailerror("Please Enter a valid email");
          return false;
        } else {
          setEmailerror(null);
          setEmail(data);
        }
        break;
    }
    return true;
  }

  if (response == true) {
    return <Navigate to="/resetpassword" replace={true} />;
  }
  return (
    <div>
      <Navbarp />

      <h1 className="text-center fs-1 m-5 p-3  fw-bold">Reset Password</h1>
      <p className="m-3 fs-3 fw-bold m-1 text-center">
        Please verify your email
      </p>
      <div className="d-flex w-100 flex-row justify-content-center">
        <div
          className="d-flex m-2 w-100 flex-column"
          style={{ "max-width": "500px" }}
        >
          <div>
            <Form className="p-1" onSubmit={handleSubmit}>
              <Form.Group className="mt-3" controlId="formBasic">
                <Form.Label className="fs-5 fw-bold m-1">
                  <i className="bi bi-envelope me-2"></i>
                  Email
                </Form.Label>
                <Form.Control
                  type="email"
                  onChange={(e) => {
                    validate(e.target.value, "email");
                  }}
                  onBlur={(e) => {
                    validate(e.target.value, "email");
                  }}
                  placeholder="Please Enter Email "
                />
                {emailerror ? (
                  <span className="text-danger m-1">{emailerror}</span>
                ) : null}
                <br />
              </Form.Group>
              <div className="d-grid gap-2">
                {message ? (
                  <span className="text-danger text-center fs-5 fw-bold m-1">
                    {message}
                  </span>
                ) : null}
                <br />
                <Button
                  variant="warning"
                  style={{ Color: "white" }}
                  size="lg"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <SmallLoader loadingtext={"Sending"} />
                  ) : (
                    "Send Otp"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forgotpassword;
